import {
  Component,
  Host,
  h,
  State,
  Listen,
  Prop,
  Event,
  EventEmitter,
} from '@stencil/core';
import {
  Language,
  SessionGuests,
  SessionRepository,
  SessionModel,
} from '@cesare';
import { QwCounterEmitter } from '../shared/qw-counter/qw-counter';
import { QwCounterId, QwGuestType } from '../../index';
import { getSessionFromSessionStorageOrEnv } from '../../core/app/app';

@Component({
  tag: 'qw-guest',
  styleUrl: 'qw-guest.scss',
  shadow: false,
})
export class QwGuest {
  @Prop() qwGuestCenter: boolean;
  @Prop() qwGuestSyncOnChange: boolean = true;
  @Prop() showInfants: boolean = false;
  @State() session: SessionModel;
  @State() guests: SessionGuests;
  @State() isSessionLoading: boolean = false;
  @Event() qwGuestChange: EventEmitter<SessionGuests>;
  @Event() qwBasketWillBeReset: EventEmitter<void>;
  @Event() clickGroupLink: EventEmitter<string>;

  public componentWillLoad() {
    this.session = getSessionFromSessionStorageOrEnv();
    this.guests = this.session.context.guests;
    if (!this.showInfants) {
      delete this.guests.infants;
    }
    SessionRepository.sessionIsLoading$.subscribe(
      (isLoading) => (this.isSessionLoading = isLoading),
    );
  }

  @Listen('qwCounterChangeValue', { target: 'window' })
  public updateConuter(event: CustomEvent<QwCounterEmitter>) {
    this.guests = { ...this.guests, [event.detail.name]: event.detail.value };
    this.qwGuestChange.emit(this.guests);

    if (!this.qwGuestSyncOnChange) {
      return;
    }
  }

  @Listen('qwResetGuest')
  public restoreGuests() {
    this.guests = {} as SessionGuests;
    setTimeout(() => (this.guests = { ...this.session.context.guests }));
  }

  private onClickInput(e: MouseEvent) {
    let element = e.target as HTMLElement;
    element.tagName === 'SPAN' ? this.clickGroupLink.emit('group') : '';
  }

  render() {
    return (
      this.guests && (
        <Host
          class={`
        ${this.qwGuestCenter ? 'qw-guest--center' : ''}
        ${this.isSessionLoading ? 'qw-guest--disabled' : ''}
      `}
        >
          {Object.keys(this.guests).map(
            (guestKey: 'adults' | 'children' | 'infants') => {
              return (
                <div class="qw-guest__counter-wrapper">
                  <div class="qw-guest__counter-wrapper__label">
                    {Language.getTranslation(guestKey)}
                    {guestKey !== 'infants' && (
                      <p class="qw-guest__counter-wrapper__sublabel">
                        {guestKey === 'adults'
                          ? Language.getTranslation('fromYearsOld')
                          : Language.getTranslation('upToYearsOld')}
                      </p>
                    )}
                  </div>
                  <qw-counter
                    qwCounterMinValue={guestKey === QwGuestType.Adults ? 1 : 0}
                    qwCounterMaxValue={
                      guestKey === QwGuestType.Adults
                        ? 14 - this.guests.children
                        : 14 - this.guests.adults
                    }
                    qwCounterId={QwCounterId.QwGuestCounter}
                    qwCounterValue={this.guests[guestKey]}
                    qwCounterName={guestKey}
                  />
                </div>
              );
            },
          )}
          {/* TODO do we need it like this */}
          <qw-input
            onClick={(e) => this.onClickInput(e)}
            qwInputIsReadonly={true}
            qwSpanEditable={true}
            class="qw-group--link"
            qwInputLabel={Language.getTranslation('groupsOfFifteen')}
            qwInputValue={Language.getTranslation('clickHereGroups')}
          />
        </Host>
      )
    );
  }
}
